var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.documentElement)?_c('root-element-fill',{attrs:{"rootElement":_vm.documentElement,"entryItems":_vm.entryItems},on:{"updated":function($event){return _vm.updated($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }